// extracted by mini-css-extract-plugin
export default {"wrapper":"u8M13aUO--styles_wrapper__XUqOK","giftCardFrameContainer":"u8M13aUO--styles_giftCardFrameContainer__Hi7AN","shimmer":"u8M13aUO--styles_shimmer__nsHgc"};